import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {TaskModel} from "../../../tasks/models/task.model";

export class fulfillmentTaskInfoCtrl implements IController {

  task: TaskModel;
  step: any;
  service: any;

  private totalItems: number;
  private currencySymbol: any;

  /* @ngInject */
  constructor(private splitService) {}

  $onInit() {
    this.currencySymbol = this.splitService.getCurrencySymbol();
    this.totalItems = _.get(this.service, 'packageList[0].count');
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentTaskInfo', {
    bindings: {
      task: '<',
      step: '<',
      service: '<'
    },
    template: require('./fulfillment-task-info.html').default,
    controller: fulfillmentTaskInfoCtrl
  });
